<svelte:options customElement={{ tag: "bt-submit-button", shadow: "none", }} />

<script lang="ts">
	import ActionButton from '$shared/action-button/ActionButton.svelte';
	import Icon from '$shared/icons/Icon.svelte'

	export let text = 'Submit';
	export let design: 'primary' | 'secondary' = 'primary';
	export let icon = '';
	export let buttonStyles = '';
	export let buttonClasses = '';
	export let iconSize: 'small' | 'medium' = 'medium';
</script>

<ActionButton design={design} buttonType="submit" {buttonStyles} {buttonClasses}>
	<span>{text}</span>
	{#if icon}
		<Icon icon={icon} size={iconSize} />
	{/if}
</ActionButton>

<style>
	:global(bt-submit-button) {
		display: block;
	}
</style>